module.exports = __webpack_public_path__ + "img/30.7c86355d.png";